"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _internalMediaCore = require("@webex/internal-media-core");
var SendSlotManager = exports.default = /*#__PURE__*/function () {
  function SendSlotManager(LoggerProxy) {
    (0, _classCallCheck2.default)(this, SendSlotManager);
    (0, _defineProperty2.default)(this, "slots", new _map.default());
    (0, _defineProperty2.default)(this, "LoggerProxy", void 0);
    this.LoggerProxy = LoggerProxy;
  }

  /**
   * This method is used to create a sendSlot for the given mediaType and returns the created sendSlot
   * @param {MultistreamRoapMediaConnection} mediaConnection MultistreamRoapMediaConnection for which a sendSlot needs to be created
   * @param {MediaType} mediaType MediaType for which a sendSlot needs to be created (AUDIO_MAIN/VIDEO_MAIN/AUDIO_SLIDES/VIDEO_SLIDES)
   * @param {boolean} active This is optional boolean to set the active state of the sendSlot. Default is true
   * @returns {SendSlot} slot The created sendSlot
   */
  (0, _createClass2.default)(SendSlotManager, [{
    key: "createSlot",
    value: function createSlot(mediaConnection, mediaType) {
      var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (this.slots.has(mediaType)) {
        throw new Error("Slot for ".concat(mediaType, " already exists"));
      }
      var slot = mediaConnection.createSendSlot(mediaType, active);
      this.slots.set(mediaType, slot);
      this.LoggerProxy.logger.info("SendSlotsManager->createSlot#Created slot for ".concat(mediaType, " with active ").concat(active));
      return slot;
    }

    /**
     * This method is used to retrieve the sendSlot for the given mediaType
     * @param {MediaType} mediaType of which the slot needs to be retrieved
     * @returns {SendSlot}
     */
  }, {
    key: "getSlot",
    value: function getSlot(mediaType) {
      var slot = this.slots.get(mediaType);
      if (!slot) {
        throw new Error("Slot for ".concat(mediaType, " does not exist"));
      }
      return slot;
    }

    /**
     * Allow users to specify 'namedMediaGroups' to indicate which named media group its audio should be sent to.
     * @param {MediaType} mediaType MediaType of the sendSlot to which the audio stream needs to be send to the media group
     * @param {[]}namedMediaGroups - Allow users to specify 'namedMediaGroups'.If the value of 'namedMediaGroups' is zero,
     * named media group will be canceled and the audio stream will be sent to the floor.
     * @returns {void}
     */
  }, {
    key: "setNamedMediaGroups",
    value: function setNamedMediaGroups(mediaType, namedMediaGroups) {
      if (mediaType !== _internalMediaCore.MediaType.AudioMain) {
        throw new Error("sendSlotManager cannot set named media group which media type is ".concat(mediaType));
      }
      var slot = this.slots.get(mediaType);
      if (!slot) {
        throw new Error("Slot for ".concat(mediaType, " does not exist"));
      }
      slot.setNamedMediaGroups(namedMediaGroups);
      this.LoggerProxy.logger.info("SendSlotsManager->setNamedMediaGroups#set named media group ".concat(namedMediaGroups));
    }

    /**
     * Sets the source state override for the given media type.
     * @param {MediaType} mediaType - The type of media (must be MediaType.VideoMain to apply source state changes).
     * @param {StreamState | null} state - The state to set or null to clear the override value.
     * @returns {void}
     */
  }, {
    key: "setSourceStateOverride",
    value: function setSourceStateOverride(mediaType, state) {
      if (mediaType !== _internalMediaCore.MediaType.VideoMain) {
        throw new Error("sendSlotManager cannot set source state override which media type is ".concat(mediaType));
      }
      var slot = this.slots.get(mediaType);
      if (!slot) {
        throw new Error("Slot for ".concat(mediaType, " does not exist"));
      }
      if (state) {
        slot.setSourceStateOverride(state);
      } else {
        slot.clearSourceStateOverride();
      }
      this.LoggerProxy.logger.info("SendSlotsManager->setSourceStateOverride#set source state override for ".concat(mediaType, " to ").concat(state));
    }

    /**
     * This method publishes the given stream to the sendSlot for the given mediaType
     * @param {MediaType} mediaType MediaType of the sendSlot to which a stream needs to be published (AUDIO_MAIN/VIDEO_MAIN/AUDIO_SLIDES/VIDEO_SLIDES)
     * @param {LocalStream} stream LocalStream to be published
     * @returns {Promise<void>}
     */
  }, {
    key: "publishStream",
    value: (function () {
      var _publishStream = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(mediaType, stream) {
        var slot;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              slot = this.slots.get(mediaType);
              if (slot) {
                _context.next = 3;
                break;
              }
              throw new Error("Slot for ".concat(mediaType, " does not exist"));
            case 3:
              _context.next = 5;
              return slot.publishStream(stream);
            case 5:
              this.LoggerProxy.logger.info("SendSlotsManager->publishStream#Published stream for ".concat(mediaType, " and stream with label ").concat(stream.label, " and muted ").concat(stream.muted));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function publishStream(_x, _x2) {
        return _publishStream.apply(this, arguments);
      }
      return publishStream;
    }()
    /**
     * This method unpublishes the stream from the sendSlot of the given mediaType
     * @param {MediaType} mediaType MediaType of the sendSlot from which a stream needs to be unpublished (AUDIO_MAIN/VIDEO_MAIN/AUDIO_SLIDES/VIDEO_SLIDES)
     * @returns {Promise<void>}
     */
    )
  }, {
    key: "unpublishStream",
    value: (function () {
      var _unpublishStream = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(mediaType) {
        var slot;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              slot = this.slots.get(mediaType);
              if (slot) {
                _context2.next = 3;
                break;
              }
              throw new Error("Slot for ".concat(mediaType, " does not exist"));
            case 3:
              _context2.next = 5;
              return slot.unpublishStream();
            case 5:
              this.LoggerProxy.logger.info("SendSlotsManager->unpublishStream#Unpublished stream for ".concat(mediaType));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function unpublishStream(_x3) {
        return _unpublishStream.apply(this, arguments);
      }
      return unpublishStream;
    }()
    /**
     * This method is used to set the active state of the sendSlot for the given mediaType
     * @param {MediaType} mediaType The MediaType of the sendSlot for which the active state needs to be set (AUDIO_MAIN/VIDEO_MAIN/AUDIO_SLIDES/VIDEO_SLIDES)
     * @param {boolean} active The boolean to set the active state of the sendSlot. Default is true
     * @returns {void}
     */
    )
  }, {
    key: "setActive",
    value: function setActive(mediaType) {
      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var slot = this.slots.get(mediaType);
      if (!slot) {
        throw new Error("Slot for ".concat(mediaType, " does not exist"));
      }
      slot.active = active;
      this.LoggerProxy.logger.info("SendSlotsManager->setActive#Set active for ".concat(mediaType, " to ").concat(active));
    }

    /**
     * This method is used to set the codec parameters for the sendSlot of the given mediaType
     * @param {MediaType} mediaType MediaType of the sendSlot for which the codec parameters needs to be set (AUDIO_MAIN/VIDEO_MAIN/AUDIO_SLIDES/VIDEO_SLIDES)
     * @param {Object} codecParameters
     * @returns {Promise<void>}
     */
  }, {
    key: "setCodecParameters",
    value: (function () {
      var _setCodecParameters = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(mediaType, codecParameters) {
        var slot;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // These codec parameter changes underneath are SDP value changes that are taken care by WCME automatically. So no need for any change in streams from the web sdk side
              slot = this.slots.get(mediaType);
              if (slot) {
                _context3.next = 3;
                break;
              }
              throw new Error("Slot for ".concat(mediaType, " does not exist"));
            case 3:
              _context3.next = 5;
              return slot.setCodecParameters(codecParameters);
            case 5:
              this.LoggerProxy.logger.info("SendSlotsManager->setCodecParameters#Set codec parameters for ".concat(mediaType, " to ").concat(codecParameters));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setCodecParameters(_x4, _x5) {
        return _setCodecParameters.apply(this, arguments);
      }
      return setCodecParameters;
    }()
    /**
     * This method is used to delete the codec parameters for the sendSlot of the given mediaType
     * @param {MediaType} mediaType MediaType of the sendSlot for which the codec parameters needs to be deleted (AUDIO_MAIN/VIDEO_MAIN/AUDIO_SLIDES/VIDEO_SLIDES)
     * @param {Array<String>} parameters Array of keys of the codec parameters to be deleted
     * @returns {Promise<void>}
     */
    )
  }, {
    key: "deleteCodecParameters",
    value: (function () {
      var _deleteCodecParameters = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(mediaType, parameters) {
        var slot;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              slot = this.slots.get(mediaType);
              if (slot) {
                _context4.next = 3;
                break;
              }
              throw new Error("Slot for ".concat(mediaType, " does not exist"));
            case 3:
              _context4.next = 5;
              return slot.deleteCodecParameters(parameters);
            case 5:
              this.LoggerProxy.logger.info("SendSlotsManager->deleteCodecParameters#Deleted the following codec parameters -> ".concat(parameters, " for ").concat(mediaType));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteCodecParameters(_x6, _x7) {
        return _deleteCodecParameters.apply(this, arguments);
      }
      return deleteCodecParameters;
    }()
    /**
     * This method is used to reset the SendSlotsManager by deleting all the sendSlots
     * @returns {undefined}
     */
    )
  }, {
    key: "reset",
    value: function reset() {
      this.slots.clear();
    }
  }]);
  return SendSlotManager;
}();
//# sourceMappingURL=sendSlotManager.js.map
